"use client";

import { useEffect } from "react";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("Page Error:", error, "pathname:", typeof window !== "undefined" ? window.location.pathname : "SSR");
  }, [error]);

  const pathname = typeof window !== "undefined" ? window.location.pathname : "SSR";
  const cause = (error as Error & { cause?: unknown }).cause;

  return (
    <div style={{ padding: "2rem", fontFamily: "monospace" }}>
      <h2 style={{ color: "#dc2626", marginBottom: "1rem" }}>页面错误</h2>
      <p style={{ marginBottom: "0.5rem" }}>
        <strong>Path:</strong> {pathname}
      </p>
      <p style={{ marginBottom: "0.5rem" }}>
        <strong>Message:</strong> {error?.message || "unknown"}
      </p>
      <p style={{ marginBottom: "0.5rem" }}>
        <strong>Digest:</strong> {error?.digest || "none"}
      </p>
      {cause && (
        <p style={{ marginBottom: "0.5rem" }}>
          <strong>Cause:</strong> {String(cause)}
        </p>
      )}
      <pre style={{ whiteSpace: "pre-wrap", fontSize: "0.85rem", color: "#666" }}>
        {error?.stack || "no stack"}
      </pre>
      <button
        onClick={() => reset()}
        style={{ marginTop: "1rem", padding: "0.5rem 1rem", cursor: "pointer" }}
      >
        重试
      </button>
    </div>
  );
}